export const DEFAULT_APP_THEME = "theme-1";
export const POINTS_CURRENCY_CODE = "STC";
export const US_CURRENCY_CODE = "USD";

export const DEMO_MODE_STORE_CURRENCY_OPTIONS = {
  [POINTS_CURRENCY_CODE]: {
    currencyCode: POINTS_CURRENCY_CODE,
    currencyName: "Points",
    currencyPrefix: "",
    currencySuffix: "Pts",
    currencyDisplayName: "POINTS",
  },
  [US_CURRENCY_CODE]: {
    currencyCode: US_CURRENCY_CODE,
    currencyName: "Credit",
    currencyPrefix: "$",
    currencySuffix: "",
    currencyDisplayName: US_CURRENCY_CODE,
  },
};

export const MOMENT_STORE_TYPE = "Spree::MomentStore";
export const ESHOP_STORE_TYPE = "Spree::EshopStore";
export const ACCOUNT_STORE_TYPE = "Spree::AccountStore";
export const CATALOG_COLLECTION_STORE_TYPE = "catalog_collection";
export const KIT_STORE_TYPE = "bundle";
export const KITS_HEADER = "kits-header";
export const CATALOG_HEADER = "catalog-header";

export const SHOP_UPDATED_MESSAGE = "Shop has been updated.";
export const SHOP_UPDATION_ERROR_MESSAGE = "An error occured in updating the shop.";
export const SHOP_CREATION_ERROR_MESSAGE = "An error occured in creating the shop.";

export const OPEN_ORDER_PREFIX_KEY = "open-order";
export const DARK_THEME = "dark";

export const VENDOR_TYPE = "Vendor";
export const BRAND_TYPE = "Brand";
export const MENUITEM_TYPE = "MenuItem";
